<div class="form-header">
    <h2 class="ud-heading-xl">Account</h2>
    <p>Edit your account settings and change your password here.</p>
</div>

<div class="um-container" style="margin-bottom:10px">
    <div class="ud-form-group">
        <label for="form-group--1" class="ud-form-label ud-heading-sm">
            Email:
        </label>
        <div class="" class="edit-account-form--form-control-container--1NHES">
            <div class="edit-account-form--fake-input--1C1DY">
                <span></span>
                <p>Your email address is <strong>{{user_email}}</strong></p>
            </div>

        </div>

    </div>
</div>
<div class="form-container">
<form [formGroup]="AccountSecurityForm" (ngSubmit)="onSubmit()"><!-- //(ngSubmit)="onSubmit()" -->

    <div *ngIf="message && loginSuccess" class="alert alert-success mb-md-3">
        {{ message}}
    </div>
    <div *ngIf="message_error && !loginSuccess" class="alert alert-danger mb-md-3">
      {{ message_error}}
      </div>
    <div class="form-group">
      <input type="password" id="f_name" formControlName="new_password" class="form-control" placeholder="Enter New Password">
    </div>

    <div class="form-group">
      <input type="pasword" id="l_name" formControlName="retry_password" class="form-control"  placeholder="Re-try New password">
    </div>
    <button type="submit"  class="btn btn-primary">Change Password</button>
</form>
</div>